import { Helpers } from '../../../utils/helpers';
import { EmailLogLookup } from '../../../components/emailLog/EmailLogLookup/EmailLogLookup';
import { EmailLogViewer } from '../EmailLogViewer/EmailLogViewer';
import useEmailLogSearch from './useEmailLogSearch';
import Container from '../../../components/ui/Container/Container';

export const EmailLogSearch = () => {
  const manager = useEmailLogSearch();

  return (
    <>
      <Container visible={Helpers.isNullOrWhiteSpace(manager.emailLogId)}>
        <div className="page-container mt-2">
          <EmailLogLookup emailLogId={manager.emailLogId} onChange={manager.emailLogSelected} />
        </div>
      </Container>
      <EmailLogViewer emailLogId={manager.emailLogId} />
    </>
  );
};
